module.exports = __webpack_public_path__ + "static/media/solution-2.fe49c763.png";